import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { DashboardPanelContext } from '../../../../components/context/DashboardContext';
import Table from '../../../../components/tables/Table';
import { SET_VIEW_READ_ONLY } from '../../../../components/context/reducer/actionTypes';
import useTableActions from '../../../../hooks/useTableActions';
import useHasPermission from '../../../../hooks/useHasPermission';
import ListsContainer from '../../../../components/ListsContainer/ListsContainer';
import EnabledColumn from '../../../../components/EnabledColumn/EnabledColumn';
import EditComponentCheckbox from '../../../../components/EditComponentCheckbox';

const EmployeeList = () => {
  const history = useHistory();
  const [pageSize, setPageSize] = useState(10);
  const [page, setPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const tableRef = useRef(null);
  const { globalDispatch, fetchItem } = useContext(DashboardPanelContext);
  const [columns, setColumns] = useState([]);
  const [data, setData] = useState([]);
  const [tableDataLoader, setTableDataLoader] = useState(false);
  const [key, setKey] = useState([]);

  const getUsersList = (pageNumber) => {
    setTableDataLoader(true);
    fetchItem({
      modelName: `/userslist?page=${pageNumber}`,
      showLoader: true,
    }).then((response) => {
      if (response) {
        setTableDataLoader(false);
        setTotalCount(response.data.total > pageSize ? response.data.total + pageSize : response.data.total);
        setData(response.data.data);
      }
    });
  };

  useEffect(() => {
    getUsersList(page);
    setColumns([
      {
        title: 'First Name',
        field: 'f_name',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Last Name',
        field: 'l_name',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Email',
        field: 'email',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Mobile',
        field: 'mobile',
        filtering: false,
        sorting: false,
      },
      {
        title: 'Is Admin',
        field: 'is_admin',
        type: 'boolean',
        render: (rowData) => (rowData.is_admin === '1' ? 'Yes' : 'No'),
        filtering: false,
        sorting: false,
      },
      {
        title: 'Status',
        field: 'enabled',
        type: 'boolean',
        render: EnabledColumn,
        editComponent: EditComponentCheckbox,
        filtering: false,
        sorting: false,
      },
    ]);
    setKey(key + 1);
  }, [page]);

  const actions = useTableActions({
    updatePermission: 'ADMIN',
    deletePermission: '',
    editURL: '/employee-management/employee/',
    removePATH: 'users',
    tableRef,
  });

  const handleCreate = () => {
    globalDispatch({ type: SET_VIEW_READ_ONLY, value: false });
    history.push('/employee-management/employee');
  };

  const onRowClick = (event, rowData) => {
    globalDispatch({ type: SET_VIEW_READ_ONLY, value: true });
    history.push(`/employee-management/employee/${rowData.id}`);
  };

  const onChangePage = (pageNumber) => {
    setPage(pageNumber === 0 ? 1 : pageNumber);
  };

  return (
    <ListsContainer>
      <Table
        key={key}
        title='Employee List'
        columns={columns}
        createSlug='Add Employee'
        exportCsv={false}
        actions={actions}
        createAction={useHasPermission('ADMIN') ? handleCreate : undefined}
        tableRef={tableRef}
        data={data}
        onRowClick={onRowClick}
        onChangeRowsPerPage={(pgSize) => {
          setPageSize(pgSize);
        }}
        pageSize={pageSize}
        paging
        filtering={false}
        totalCount={totalCount}
        page={page}
        onChangePage={onChangePage}
        sortableColumns
        isLoading={tableDataLoader}
      />
    </ListsContainer>
  );
};

export default EmployeeList;
